function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ApolloLink } from '@apollo/client';
import { Headers } from '@sail/data';
import addHttpHeaders from '../../addHttpHeaders';
import getSchemaVersion from '../../getSchemaVersion';
import addContextHeaders from '../../addContextHeaders';
export default function createHttpHeadersLink(routeThroughEdge) {
    const schemaVersion = getSchemaVersion();
    return new ApolloLink(function httpHeadersLink(operation, forward) {
        const v2Context = operation.variables.v2Context || {};
        operation.setContext(function contextWithHeaders(prevContext) {
            var _prevContext_headers;
            const headers = new Headers([
                ...Object.entries((_prevContext_headers = prevContext === null || prevContext === void 0 ? void 0 : prevContext.headers) !== null && _prevContext_headers !== void 0 ? _prevContext_headers : {})
            ]);
            // TODO(MOVE_TO_V2CONTEXTINPUT): This should just be (headers, v2Context).
            addContextHeaders(headers, {
                id: v2Context.id || null
            }, routeThroughEdge);
            addHttpHeaders(headers, schemaVersion, routeThroughEdge);
            // TODO: Enforce that operation name is present for all queries.
            if (operation.operationName != null) {
                headers.set('X-Stripe-Graphql-Operation', operation.operationName);
            }
            return _object_spread_props(_object_spread({}, prevContext), {
                headers: headers.getFetchHeaders()
            });
        });
        return forward(operation);
    });
}

//# sourceMappingURL=createHttpHeadersLink.js.map